import React from 'react';
import './Legal.css';

function Cookies() {
  return (
    <div className="legal-page">
      <div className="legal-hero">
        <h1>Politique des Cookies</h1>
        <p>Dernière mise à jour: {new Date().toLocaleDateString()}</p>
      </div>

      <div className="legal-content">
        <section>
          <h2>1. Qu'est-ce qu'un Cookie ?</h2>
          <p>Les cookies sont de petits fichiers texte qui sont stockés sur votre appareil lorsque vous visitez notre site web. Ils servent à :</p>
          <ul>
            <li>Améliorer votre expérience de navigation</li>
            <li>Mémoriser vos préférences</li>
            <li>Analyser l'utilisation de notre site</li>
            <li>Personnaliser le contenu</li>
          </ul>
        </section>

        <section>
          <h2>2. Types de Cookies Utilisés</h2>
          <p>Notre site utilise différents types de cookies :</p>
          <ul>
            <li>Cookies essentiels pour le fonctionnement du site</li>
            <li>Cookies analytiques pour comprendre l'utilisation</li>
            <li>Cookies de préférences</li>
            <li>Cookies publicitaires (avec votre consentement)</li>
          </ul>
        </section>

        <section>
          <h2>3. Gestion des Cookies</h2>
          <p>Vous pouvez gérer vos préférences de cookies de plusieurs façons :</p>
          <ul>
            <li>Via les paramètres de votre navigateur</li>
            <li>Notre bannière de consentement aux cookies</li>
            <li>En nous contactant directement</li>
          </ul>
        </section>

        <section>
          <h2>4. Durée de Conservation</h2>
          <p>La durée de conservation des cookies varie selon leur type :</p>
          <ul>
            <li>Cookies de session : supprimés à la fermeture du navigateur</li>
            <li>Cookies persistants : jusqu'à 13 mois maximum</li>
            <li>Cookies analytiques : 12 mois maximum</li>
          </ul>
        </section>

        <section>
          <h2>5. Nous Contacter</h2>
          <div className="contact-info">
            <p>Pour toute question sur notre utilisation des cookies :</p>
            <p>Email: privacy@taxivd.ch</p>
            <p>Téléphone: +41 XX XXX XX XX</p>
            <p>Adresse: Lausanne, Suisse</p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Cookies; 